/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * sim_result.csvの1行分のデータ
 * @export
 * @interface SchemasSystemSimResultData
 */
export interface SchemasSystemSimResultData {
    /**
     * 
     * @type {string}
     * @memberof SchemasSystemSimResultData
     */
    datetime: string;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    wlevel?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    flow?: number;
    /**
     * 降水量
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    r?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    ruika?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    wlevelNodam?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    flowNodam?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    qinAll?: number;
    /**
     * 放流量
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    qoutAll?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasSystemSimResultData
     */
    preStage?: number;
}

/**
 * Check if a given object implements the SchemasSystemSimResultData interface.
 */
export function instanceOfSchemasSystemSimResultData(value: object): value is SchemasSystemSimResultData {
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    return true;
}

export function SchemasSystemSimResultDataFromJSON(json: any): SchemasSystemSimResultData {
    return SchemasSystemSimResultDataFromJSONTyped(json, false);
}

export function SchemasSystemSimResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchemasSystemSimResultData {
    if (json == null) {
        return json;
    }
    return {
        
        'datetime': json['datetime'],
        'wlevel': json['wlevel'] == null ? undefined : json['wlevel'],
        'flow': json['flow'] == null ? undefined : json['flow'],
        'r': json['R'] == null ? undefined : json['R'],
        'ruika': json['Ruika'] == null ? undefined : json['Ruika'],
        'wlevelNodam': json['wlevel_nodam'] == null ? undefined : json['wlevel_nodam'],
        'flowNodam': json['flow_nodam'] == null ? undefined : json['flow_nodam'],
        'qinAll': json['Qin_all'] == null ? undefined : json['Qin_all'],
        'qoutAll': json['Qout_all'] == null ? undefined : json['Qout_all'],
        'preStage': json['preStage'] == null ? undefined : json['preStage'],
    };
}

export function SchemasSystemSimResultDataToJSON(json: any): SchemasSystemSimResultData {
    return SchemasSystemSimResultDataToJSONTyped(json, false);
}

export function SchemasSystemSimResultDataToJSONTyped(value?: SchemasSystemSimResultData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datetime': value['datetime'],
        'wlevel': value['wlevel'],
        'flow': value['flow'],
        'R': value['r'],
        'Ruika': value['ruika'],
        'wlevel_nodam': value['wlevelNodam'],
        'flow_nodam': value['flowNodam'],
        'Qin_all': value['qinAll'],
        'Qout_all': value['qoutAll'],
        'preStage': value['preStage'],
    };
}

